import { Box, Divider, Grid, Icon, TextField, Typography } from "@mui/material";
import { CustomButton } from "components/roundedbutton/CustomButton";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import HeaderOuBannerDependendoDaInterpretacaoH1, { headerOuBannerDependendoDaInterpretacaoH1defaultFontSize } from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { CustomSwitch } from "pages/cadastro-pessoa/CadastroPessoa";
import CustomPoliticaVenda from "pages/Venda/CustomPoliticaVenda";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { ConfiguracoesChildrenProps } from "../Configuracoes";
import { ConfiguracoesTitle } from "../Configuracoes.model";
import ConfiguracaoDescontoAcrescimoService from "../configuracao-desconto-acrescimo.service";
import { FlowConfiguracaoPoliticaVendaDTO } from "./politica-venda.model";
import { theme } from "theme";

const initialState = {
    obrigaNsu: false as boolean,
    obrigaNumeroControle: false as boolean,
    observacaoFixa: '' as string
};

const ConfigurarPoliticaVenda = (props: ConfiguracoesChildrenProps) => {
    const configuracaoService = ConfiguracaoDescontoAcrescimoService();
    const [stateLocal, setStateLocal] = useState(initialState);
    const { addError, addSuccess } = useSnackbarCustom();
    const isFirstRenderRef = useRef<boolean>(true);
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado);

    const onChangeNSU = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, obrigaNsu: !prevState.obrigaNsu }));
    }, []);

    const onChangeNumeroControle = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, obrigaNumeroControle: !prevState.obrigaNumeroControle }));
    }, []);

    const onChangeObservacaoFixa = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setStateLocal(prevState => ({
            ...prevState,
            observacaoFixa: e.target.value
        }));
    }
        , []);

    const getConfiguracaoPoliticaVenda = useCallback(async () => {
        try {
            const { data: FlowConfiguracaoPoliticaVendaDTO } = await configuracaoService.getConfiguracaoPoliticaVenda();
            if (FlowConfiguracaoPoliticaVendaDTO) {
                setStateLocal(prevState => ({
                    ...prevState,
                    obrigaNsu: FlowConfiguracaoPoliticaVendaDTO.obrigaNsu,
                    obrigaNumeroControle: FlowConfiguracaoPoliticaVendaDTO.obrigaNumeroControle,
                    observacaoFixa: FlowConfiguracaoPoliticaVendaDTO.observacaoFixa ?? ''
                }));
            }
        } catch (err) {
            addError({ message: "Não foi possível carregar suas configurações de política de venda", closeable: true });
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const updateConfiguracaoPoliticaVenda = useCallback(async (obrigaNsu: boolean, obrigaNumeroControle: boolean, observacaoFixa: string) => {
        const toSave: FlowConfiguracaoPoliticaVendaDTO = {
            obrigaNsu,
            obrigaNumeroControle,
            observacaoFixa

        };
        try {
            const { data } = await configuracaoService.updateConfiguracaoPoliticaVenda(toSave);
            if (data) {
                addSuccess({ message: 'configuração política de venda atualizada com sucesso.', closeable: false });
                props.onGoBack();
            }
        } catch (err) {
            addError({ message: "Não foi possivel atualizar suas configuracoes de política de venda", closeable: true });
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isFirstRenderRef.current) getConfiguracaoPoliticaVenda();
        isFirstRenderRef.current = false;
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        getConfiguracaoPoliticaVenda();
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado]);

    return (
        <>
            <HeaderOuBannerDependendoDaInterpretacaoH1
                id='configurar_politica_venda_header_or_banner'
                customIcon={
                    <CustomPoliticaVenda
                        id="configurar_politica_venda_icon_header"
                        color={theme.palette.text.primary}
                        fontSize={headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal}
                        style={{ marginBottom: '5px' }}
                    />
                }
                label={ConfiguracoesTitle.CONFIGURACAO_POLITICA_VENDA}
            />

            <Grid
                container
                spacing={2}
                alignContent={'flex-start'}
                sx={{
                    height: '85%',
                    position: 'relative'
                }}
            >
                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Configuração obrigatoriedade cartão
                    </Typography>
                    <Divider />
                </Grid>



                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Obrigar informar NSU
                        </Typography>

                        <CustomSwitch
                            id='obriga-informar-nsu'
                            checked={stateLocal.obrigaNsu}
                            onChange={onChangeNSU}
                            name="obriga-informar-nsu" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            marginTop: '20px'
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Obrigar informar número de controle
                        </Typography>

                        <CustomSwitch
                            id='obriga-informar-numero-controle'
                            checked={stateLocal.obrigaNumeroControle}
                            onChange={onChangeNumeroControle}
                            name="obriga-informar-numero-controle" />
                    </Box>

                </Grid>

                <Grid item xs={12} md={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <TextField
                            multiline
                            fullWidth
                            label="Observação fixa para pedidos de romaneio"
                            maxRows={15}
                            variant="standard"
                            value={stateLocal.observacaoFixa}
                            onChange={onChangeObservacaoFixa}
                            inputProps={{ maxLength: 3500 }}
                            helperText={`Máximo de 3500 caracteres. ${stateLocal.observacaoFixa.length}/3500`}
                        />
                    </Box>
                </Grid>

                <Grid item
                    sx={{
                        position: 'absolute',
                        bottom: '15px',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                    }}
                >
                    <CustomButton
                        sx={{ minWidth: '80px' }}
                        id="voltar-configuracao-vale-presente-btn"
                        onClick={props.onGoBack}
                        variant="contained"
                        color="error"
                        startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                        Voltar
                    </CustomButton>

                    <CustomButton
                        sx={{ minWidth: '80px' }}
                        id="voltar-configuracao-vale-presente-btn"
                        onClick={() => updateConfiguracaoPoliticaVenda(stateLocal.obrigaNsu, stateLocal.obrigaNumeroControle, stateLocal.observacaoFixa)}
                        variant="contained"
                        color="success"
                        startIcon={<Icon className='fa-solid fa-check' />}>
                        Salvar
                    </CustomButton>
                </Grid>
            </Grid>
        </>
    );
};

export default ConfigurarPoliticaVenda;
